import { useEffect, useRef } from "react";
import { Input } from "antd";
import { useNodesTitle } from "@custom-hooks/HomeUsePluginRoot/useNodesTitle";
import style from "../index.module.scss";
import func from "@uikit/func";
import { TextAreaRef } from "antd/lib/input/TextArea";
import { useReactFlow } from "reactflow";
import { useAISaasContainer } from "@uiview/views/AISaas/container";
import { useRenderData } from "../../hooks/useRenderData";
import { useAISaasPreviewItem } from "../../hooks/useAISaasPreviewItem";
import { useSignal } from "@preact/signals-react";
import { useAiSaasInputContainer } from "@uiview/views/AISaas/AISaasInput/container";

type PreviewTitleProps = {
  id: string;
  title: string;
  isShare: boolean;
  showInputTitleId: string;
  saasUIInputData: any;
  inputTitleId: string;
  onSaasInputTitleChange: (e: any, id: string) => void;
  onInputTitleEnter: (e: any, id: string) => void;
  onInputTitleBlur: (id: string) => void;
  onClickInputTitleClose: (e: any, id: string) => void;
  onClickEdit: (e: any, data: any, tips: string | string[]) => void;
};

const hideAndDisplay = (key: boolean) => {
  return key ? style["display-box"] : style["hide-box"];
};

export function PreviewTitle({
  isShare,
  saasUIInputData,
  inputTitleId,
  onInputTitleBlur,
  onInputTitleEnter,
  onSaasInputTitleChange,
  onClickInputTitleClose,
  onClickEdit,
  showInputTitleId,
}: PreviewTitleProps) {
  const isHover = useSignal(false);
  const inputTitleRef = useRef(null);
  const { getNode } = useReactFlow();
  const { handleBlur, handleChange, handleEnter, handleFocus, saveTitle, inputTitle } = useNodesTitle(
    saasUIInputData.id
  );

  const renderData = useRenderData({ type: "inputLabel", id: saasUIInputData.id });

  useEffect(() => {
    const node = getNode(saasUIInputData.id);
    if (!node?.data?.generatedLabel && !node?.data?.inputTitle) {
      saveTitle("User Input");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { onPreviewItemMouseEnter, onPreviewItemMouseLeave } = useAISaasPreviewItem();
  const { selectTips, setSelectTips } = useAiSaasInputContainer();
  const inputRef = useRef<TextAreaRef>(null);

  const clickEdit = (tips: string | string[]) => {
    if (!func.isEmpty(inputRef.current)) {
      inputRef.current?.focus({
        cursor: "end",
      });
    }
    onClickEdit(null, saasUIInputData, tips);
  };

  const hideAndDisplay = (key: boolean) => {
    return key ? style["display-box"] : style["hide-box"];
  };

  const isEditing = saasUIInputData.id === inputTitleId;
  useEffect(() => {
    if (selectTips.value.id === saasUIInputData.id && selectTips.value.type === "inputNodeLabel") {
      onPreviewItemMouseEnter(getMouseEnterParams());
    }
  }, [selectTips.value]);

  const getMouseEnterParams = () => {
    return {
      type: "inputNodeLabel",
      id: saasUIInputData.id,
      item: saasUIInputData,
      container: inputTitleRef.current,
      edit: clickEdit,
      remove: () => {
        onClickInputTitleClose(null, saasUIInputData.id);
        saveTitle("");
      },
      selectTips: selectTips.value,
    };
  };

  return (
    <div
      style={{ ...renderData?.style, flex: 1, width: "100%" }}
      ref={inputTitleRef}
      onMouseEnter={() => {
        onPreviewItemMouseEnter(getMouseEnterParams());
        isHover.value = true;
      }}
      onMouseLeave={e => {
        onPreviewItemMouseLeave(e);
        isHover.value = false;
      }}
    >
      <div className={`${style["edit-box"]} ${hideAndDisplay(isHover.value)}`}></div>
      {!isEditing && (
        <div style={renderData?.style} className={`${style["input-title-piece"]} ${hideAndDisplay(!isEditing)}`}>
          {inputTitle}
        </div>
      )}
      {!isShare && (
        <Input.TextArea
          style={{ ...renderData?.style, display: isEditing ? "initial" : "none" }}
          value={inputTitle}
          ref={inputRef}
          autoSize={{ minRows: 1, maxRows: 10 }}
          className={`${style["input-title"]} ${hideAndDisplay(isEditing)} ${
            isEditing ? style["input-title-textArea-display-zIndex"] : null
          }`}
          bordered={false}
          onChange={e => {
            onSaasInputTitleChange(e, saasUIInputData.id);
            handleChange(e);
          }}
          onPressEnter={e => {
            onInputTitleEnter(e, saasUIInputData.id);
            inputRef.current?.blur();
          }}
          onFocus={handleFocus}
          onBlur={() => {
            onInputTitleBlur(saasUIInputData.id);
            handleBlur();
          }}
        />
      )}
    </div>
  );
}
